import { render, staticRenderFns } from "./SignWrite.vue?vue&type=template&id=3284f8ab&scoped=true&"
import script from "./SignWrite.vue?vue&type=script&lang=ts&"
export * from "./SignWrite.vue?vue&type=script&lang=ts&"
import style0 from "./SignWrite.vue?vue&type=style&index=0&id=3284f8ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3284f8ab",
  null
  
)

export default component.exports